export default (data) => [
  { label: 'First name', type: 'text', id: 'fname', defaultValue: data.fname },
  { label: 'Last name', type: 'text', id: 'lname', defaultValue: data.lname },
  { label: 'Date of birth', type: 'date', id: 'dob', defaultValue: data.dob },
  { label: 'Contact number', type: 'tel', id: 'phone', defaultValue: data.phone },
  { label: 'Email address', type: 'email', id: 'email', defaultValue: data.email },
  { label: 'Preferred start date', type: 'date', id: 'start', defaultValue: data.start },
];
